"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingParticipantMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const meeting_entity_1 = require("./meeting.entity");
let MeetingParticipantMap = class MeetingParticipantMap {
    constructor(meetingId, participantId, participantCompanyId, participantRecordType) {
        this.meetingId = meetingId;
        this.participantId = participantId;
        this.participantCompanyId = participantCompanyId;
        this.participantRecordType = participantRecordType;
    }
};
exports.MeetingParticipantMap = MeetingParticipantMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MeetingParticipantMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "meeting_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MeetingParticipantMap.prototype, "meetingId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "participant_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MeetingParticipantMap.prototype, "participantId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({
        name: "participant_record_type",
        type: "varchar",
        length: 25,
        nullable: false,
    }),
    tslib_1.__metadata("design:type", String)
], MeetingParticipantMap.prototype, "participantRecordType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "participant_company_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], MeetingParticipantMap.prototype, "participantCompanyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => meeting_entity_1.Meeting, (meeting) => meeting.participants, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "meeting_id" }),
    tslib_1.__metadata("design:type", Object)
], MeetingParticipantMap.prototype, "meeting", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], MeetingParticipantMap.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
        onUpdate: "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], MeetingParticipantMap.prototype, "updatedAt", void 0);
exports.MeetingParticipantMap = MeetingParticipantMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("meeting_participant_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number, String])
], MeetingParticipantMap);
